import React from 'react';

import type { EditablePageProps } from '@/components/aem-core/editable-page/typings';
import AuthoringHelper from '@/utils/authoring';
import { EditableComponent, Page } from '@adobe/aem-react-editable-components';
import { ComponentMapping } from '@adobe/aem-spa-component-mapping';
import { Constants } from '@adobe/aem-spa-page-model-manager';

const { CHILDREN_PROP, ITEMS_PROP, ITEMS_ORDER_PROP, PATH_PROP } = Constants;

const EditablePage: React.FC<EditablePageProps> = ({ pageModel }) => {
	return (
		<EditableComponent
			isInEditor={AuthoringHelper.isInEditor}
			cqPath={pageModel[PATH_PROP]}
			model={pageModel}
		>
			<Page
				isInEditor={AuthoringHelper.isInEditor}
				cqChildren={
					AuthoringHelper.isInEditor
						? pageModel[CHILDREN_PROP]
						: undefined
				}
				cqItems={pageModel[ITEMS_PROP]}
				cqItemsOrder={pageModel[ITEMS_ORDER_PROP]}
				cqPath={pageModel[PATH_PROP]}
				componentMapping={ComponentMapping}
			/>
		</EditableComponent>
	);
};

export default EditablePage;
